import { withDomains } from "../lib/domain";
import React, { useEffect, useState } from "react";
import { RESTExecutor } from "../lib/domain";
import {
  Menu,
  Dropdown,
  message,
  Button,
  Modal,
  Spin,
  Empty,
  Row,
  Col,
  Tooltip,
} from "antd";
import {
  CloseOutlined,
  ExclamationCircleOutlined,
  MoreOutlined,
} from "@ant-design/icons";
import { BASE_API_URL } from "../config";
import { getImageUrl } from "../util/ui_util";
import { SearchIcon, WarnIcon } from "../assets/icons";
import { ViewSwitch } from "../components/ViewSwitch";
import differenceInCalendarDays from "date-fns/differenceInCalendarDays";
import { Pagination } from "./Pagnination";
import Text from "antd/lib/typography/Text";
import { WelcomeModal } from "./welcomeModal";
import { EmptyState } from "./empty-state";
import { useMediaQuery } from "./useMediaQuery";

let userName = "";
let imgSource = "";
const { confirm } = Modal;

function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}

const OrganizationList = ({ domains, authenticator, userInfo, ...props }) => {
  const [view, setView] = React.useState("LIST");
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = React.useState(true);
  const [filterQuery, setFilterQuery] = React.useState({
    limit: 20,
    page: 1,
  });
  const [searchQuery, setSearchQuery] = useState("");

  let list_namespace = RESTExecutor.list()
    .config({
      label: "list_namespace",
    })
    .callbacks(
      (success) => {
        console.log({ success });
        if (success.result?.length === 0) {
          setShowModal(true);
        }
        setLoading(false);
      },
      (error) => {
        console.log(error);
        error.error_message && message.error(error.error_message);
        setLoading(false);

      }
    )
    .connect(domains.user);

  let leave_company = RESTExecutor.post()
    .config({
      label: "leave_company",
      url: `/leave-company`,
    })
    .callbacks(
      (success) => {
        // message.success("You have successfully left the company");
        list_namespace.execute(true);
      },
      (error) => message.error(error.error_message)
    )
    .connect(domains.user);

  // let respond_to_invitation = RESTExecutor.post()
  //   .config({
  //     label: "respond_to_invitation",
  //   })
  //   .callbacks((success) => {
  //     namespace_invitations.execute(true);
  //     list_namespace.execute(true);
  //   })
  //   .connect(domains.user);

  let upgrade_credentials = RESTExecutor.post()
    .config({
      label: "upgrade_credentials",
    })
    .connect(domains.upgradeCredentials);

  useEffect(() => {
    list_namespace
      .config({
        params: { page: filterQuery?.page, limit: filterQuery?.limit },
      })
      .execute(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterQuery]);

  let namespace_resp = list_namespace.response();
  // let invitations_resp = namespace_invitations.response();
  // let invite_resp = respond_to_invitation.response();

  // let companies_resp = get_companies.response();
  // let result = user_resp.result;

  // console.log(invite_resp.result, "hello");

  const onLeaveCompany = ({ id }) => {
    function leaveCompany() {
      leave_company.config({ url: `/leave-company/${id}` });
      leave_company.execute();
    }
    showPromiseConfirm(
      "Do you really want to leave the company?",
      leaveCompany
    );
  };

  const companyMenu = (id) => {
    return (
      <Menu>
        {/* <Menu.Item
            icon={<MailOutlined />}
            onClick={() => {
              window.open(`mailto:${email}?subject=${title}`)
            }}
          >
            Contact Admin
          </Menu.Item> */}
        <Menu.Item
          icon={<CloseOutlined />}
          onClick={() => {
            function leaveCompany() {
              leave_company.config({ url: `/leave-company/${id}` });
              leave_company.execute();
            }
            showPromiseConfirm(
              "Do you really want to leave the company?",
              leaveCompany
            );
          }}
        >
          Leave Company
        </Menu.Item>
      </Menu>
    );
  };

  function showPromiseConfirm(title, ok) {
    confirm({
      title: title,
      content: "This action cannot be reversed",
      icon: <ExclamationCircleOutlined />,
      onOk() {
        ok();
      },
      onCancel() {},
    });
  }

  const onTiggOpenClick = (item) => {
    const domainUrl = process.env.REACT_APP_TIGG_DOMAIN_URL;

    upgrade_credentials.onSuccess = (resp) => {
      let str = "";
      Object.entries(resp.result).map(([k, v]) => (str += `${k}=${v}&`));
      let staging = BASE_API_URL.includes("demo.tigg")
        ? "/demo/v1"
        : BASE_API_URL.includes("uat.tigg")
        ? "/staging"
        : "";

      window.open(
        `https://${item?.slug}.${domainUrl}/#/validate-login?${str.slice(
          0,
          -1
        )}`
        // `https://${item.slug}.tigg.app${staging}/#/validate-login?${str.slice(
        //   0,
        //   -1
        // )}`
      );
    };
    upgrade_credentials.execute({
      namespace: `${item.slug}`,
    });
  };

  const onPosOpenClick = (item) => {
    const domainUrl = process.env.REACT_APP_POS_DOMAIN_URL;
    upgrade_credentials.onSuccess = (resp) => {
      let str = "";
      Object.entries(resp.result).map(([k, v]) => (str += `${k}=${v}&`));
      let staging = BASE_API_URL.includes("demo.tigg")
        ? "/demo/v1"
        : BASE_API_URL.includes("uat.tigg")
        ? "/staging"
        : "";
      window.open(
        `https://${item?.slug}.${domainUrl}/auth/validate-login?${str.slice(
          0,
          -1
        )}`
        // `https://${item.slug}.tigg.app${staging}/#/validate-login?${str.slice(
        //   0,
        //   -1
        // )}`
      );
    };
    upgrade_credentials.execute({
      namespace: `${item.slug}`,
    });
  };

  const onReportOpenClick = (item) => {
    const domainUrl = process.env.REACT_APP_TIGG_DOMAIN_URL;

    upgrade_credentials.onSuccess = (resp) => {
      let str = "";
      Object.entries(resp.result).map(([k, v]) => (str += `${k}=${v}&`));
      let staging = BASE_API_URL.includes("demo.tigg")
        ? "/demo/v1"
        : BASE_API_URL.includes("uat.tigg")
        ? "/staging"
        : "";

      window.open(
        `http://${item?.slug}.${domainUrl}/#/validate-login?${str.slice(
          0,
          -1
        )}&is_bank_user=true`
        // `https://${item.slug}.tigg.app${staging}/#/validate-login?${str.slice(
        //   0,
        //   -1
        // )}`
      );
    };
    upgrade_credentials.execute({
      namespace: `${item.slug}`,
    });
  };

  const dataLength = namespace_resp?.result?.length;

  const onSearch = debounce((val) => {
    setSearchQuery(val);
    setLoading(true);
    list_namespace
      .config({ params: { search_phrase: val } })
      .callbacks(() => {
        setShowModal(false);
        setLoading(false);
      })
      .execute(true);
  });

  // React.useEffect(() => {
  //   if (dataLength <= 8) {
  //     setView("GRID");
  //   } else {
  //     setView("LIST");
  //   }

  // }, [dataLength]);

  // React.useEffect(() => {
  //   console.log('I Ran')
  //   if(dataLength === 0  && !loading){
  //     setShowModal(true)
  //   }
  // },[dataLength, loading])

  const isSmall = useMediaQuery("(max-width: 576px)");

  useEffect(() => {
    if (isSmall) {
      setView("GRID");
    }
  }, [isSmall]);

  return (
    <>
      <WelcomeModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        {...props}
      />
      <div
        className="list_header"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div className="company-card-menu-header">Organization List</div>
        <div className="list_header__filters">
          <div className="list_header__filters_input border_element">
            <SearchIcon style={{ color: "var(--gray50)" }} />
            <input
              placeholder="Search Organization"
              onChange={(e) => onSearch(e.target.value)}
            />
          </div>
          <ViewSwitch value={view} onChange={(view) => setView(view)} />
        </div>
      </div>
      {loading ? (
        <Spin spinning={loading} tip="Loading.." />
      ) : dataLength === 0 && !searchQuery ? (
        <EmptyState
          title="Create Your First Organization"
          description="Lets create your first organization together. Click the button below to get started and effortlessly manage your accounts."
          onButtonClick={() => {
            props.history.push({ pathname: `/new-company` });
          }}
        />
      ) : dataLength === 0 && searchQuery ? (
        <>No Search Results Found!</>
      ) : (
        <>
          {view === "GRID" && (
            <GridView
              isLoading={loading}
              data={namespace_resp?.result}
              onPosOpenClick={onPosOpenClick}
              onTiggOpenClick={onTiggOpenClick}
              onLeaveCompany={onLeaveCompany}
              emptyBody={
                <Button style={{ borderRadius: "4px" }} type="primary">
                  New Organization
                </Button>
              }
            >
              {namespace_resp?.result?.map((d) => (
                <>
                  <CompanyCardGridItem
                    key={d?.slug}
                    onPosOpenClick={onPosOpenClick}
                    onTiggOpenClick={onTiggOpenClick}
                    onLeaveCompany={onLeaveCompany}
                    menu={companyMenu(d?.id)}
                    data={d}
                  />
                </>
              ))}
            </GridView>
          )}
          {view === "LIST" && (
            <ListView data={namespace_resp?.result} isLoading={loading}>
              {namespace_resp?.result?.map((d) => (
                <>
                  <CompanyListViewItem
                    key={d?.slug}
                    onPosOpenClick={onPosOpenClick}
                    onTiggOpenClick={onTiggOpenClick}
                    onReportOpenClick={onReportOpenClick}
                    onLeaveCompany={onLeaveCompany}
                    menu={companyMenu(d?.id)}
                    data={d}
                    userInfo={userInfo}
                  />
                </>
              ))}
            </ListView>
          )}
        </>
      )}

      {namespace_resp?.meta?.total > 20 && (
        <Pagination
          filterQuery={filterQuery}
          metaData={namespace_resp?.meta}
          setFilterQuery={setFilterQuery}
        />
      )}
    </>
  );
};

const CompanyCardGridItem = ({
  menu,
  data,
  onPosOpenClick,
  onTiggOpenClick,
}) => {
  const subTitle = `${data?.slug}.tigg.app`;
  const title = data?.name;

  const avatar = getImageUrl(data)
    ? getImageUrl(data)
    : `https://ui-avatars.com/api/?name=${data?.name?.split(" ")[0]}+${
        data?.name?.split(" ")[1]
      }&background=393965&color=fff`;

  const remainingDays = differenceInCalendarDays(
    new Date(data?.expiry_date?.split("-")?.reverse().join("-")),
    new Date()
  );

  const isWarningShown =
    data?.subscription_status !== "Demo" &&
    data?.managed_by !== "partner" &&
    remainingDays <= 14 &&
    remainingDays > 0;
  const isDemo = data?.subscription_status === "Demo";
  const isExpiredShown =
    data?.subscription_status !== "Demo" &&
    data?.managed_by !== "partner" &&
    remainingDays <= 0;
  const color = isWarningShown
    ? "var(--feedback-credit)"
    : isExpiredShown
    ? "var(--feedback-danger)"
    : isDemo
    ? "var(--feedback-credit)"
    : "";

  return (
    <Col xs={24} md={8} xl={6}>
      <div className="company_card border_layout">
        <div className="company_card__header">
          {(isDemo || isWarningShown || isExpiredShown) && (
            <div
              style={{
                display: "flex",
                gap: "4px",
                alignItems: "center",
                color: color,
              }}
            >
              <WarnIcon size="sm" />
              <span style={{ fontSize: "14px", fontWeight: 500 }}>
                {isDemo && `Trial Ends in ${remainingDays} days`}
                {!isDemo &&
                  isWarningShown &&
                  `Subscription left ${remainingDays} days`}
                {!isDemo &&
                  isExpiredShown &&
                  `Subscription expired ${Math.abs(remainingDays)} days ago`}
              </span>
            </div>
          )}
          <div style={{ marginLeft: "auto" }}>
            <Dropdown overlay={menu} trigger={["click"]}>
              <MoreOutlined />
            </Dropdown>
          </div>
        </div>
        <div className="company_card__body">
          <img src={avatar} alt={data?.slug} />
          <div
            style={{
              gap: "4px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              paddingLeft: "12px",
              paddingRight: "12px",
            }}
          >
            <CardTitle title={title} />

            <div
              style={{
                fontSize: "13px",
                fontWeight: "400",
                color: "var(--gray50)",
              }}
            >
              {subTitle}
            </div>
          </div>
        </div>
        <div className="company_card__footer">
          {data?.is_tigg_enabled && (
            <Button onClick={() => onTiggOpenClick(data)}>Open Tigg</Button>
          )}
          {data?.is_pos_enabled && (
            <Button onClick={() => onPosOpenClick(data)}>Open Pos</Button>
          )}
        </div>
      </div>
    </Col>
  );
};

const CompanyListViewItem = ({
  userInfo,
  data,
  menu,
  onTiggOpenClick,
  onPosOpenClick,
  onReportOpenClick,
}) => {
  const subTitle = `${data?.slug}.tigg.app`;
  const title = data?.name;

  const avatar = getImageUrl(data)
    ? getImageUrl(data)
    : `https://ui-avatars.com/api/?name=${data?.name?.split(" ")[0]}+${
        data?.name?.split(" ")[1]
      }&background=393965&color=fff`;

  const remainingDays = differenceInCalendarDays(
    new Date(data?.expiry_date?.split("-")?.reverse().join("-")),
    new Date()
  );

  const isWarningShown =
    data?.subscription_status !== "Demo" &&
    data?.managed_by !== "partner" &&
    remainingDays <= 14 &&
    remainingDays > 0;

  const isDemo = data?.subscription_status === "Demo";
  const isExpiredShown =
    data?.subscription_status !== "Demo" &&
    data?.managed_by !== "partner" &&
    remainingDays <= 0;
  const color = isWarningShown
    ? "var(--warning)"
    : isExpiredShown
    ? "var(--danger)"
    : isDemo
    ? "var(--warning)"
    : "";

  const is_bank_user = userInfo?.is_bank_user;

  return (
    <div className="company_list">
      <div className="company_list__left">
        <img src={avatar} alt={data?.slug} />
        <div className="company_list__left_detail">
          <div style={{ fontSize: "16px", fontWeight: "500" }}>{title}</div>
          <div
            style={{
              fontSize: "12px",
              fontWeight: "400",
              color: "var(--gray50)",
            }}
          >
            {subTitle}
          </div>
        </div>
      </div>
      <div className="company_list__right">
        {!is_bank_user && (isDemo || isWarningShown || isExpiredShown) && (
          <div
            style={{
              display: "flex",
              gap: "4px",
              alignItems: "center",
              color: color,
            }}
          >
            <WarnIcon size="sm" />
            <span style={{ fontSize: "14px", fontWeight: 500 }}>
              {isDemo && `Trial Ends in ${remainingDays} days`}
              {!isDemo &&
                isWarningShown &&
                `Subscription left ${remainingDays} days`}
              {!isDemo &&
                isExpiredShown &&
                `Subscription expired ${Math.abs(remainingDays)} days ago`}
            </span>
          </div>
        )}

        {is_bank_user && (
          <Button
            style={{ borderRadius: "6px" }}
            onClick={() => onReportOpenClick(data)}
          >
            Open Report
          </Button>
        )}

        {!is_bank_user && (
          <div style={{ display: "flex", gap: "6px" }}>
            {data?.is_tigg_enabled && (
              <Button
                style={{ borderRadius: "6px" }}
                onClick={() => onTiggOpenClick(data)}
              >
                Open Tigg
              </Button>
            )}
            {data?.is_pos_enabled && (
              <Button
                style={{ borderRadius: "6px" }}
                onClick={() => onPosOpenClick(data)}
              >
                Open Pos
              </Button>
            )}
          </div>
        )}
        <div>
          <Dropdown overlay={menu} trigger={["click"]}>
            <MoreOutlined />
          </Dropdown>
        </div>
      </div>
    </div>
  );
};

const ListView = ({ children, data, isLoading = false }) => {
  if (data?.length === 0) {
    return <Empty description="No Data Available!" />;
  }
  return (
    <Spin spinning={isLoading} tip="Loading" size="large">
      <div className="list_view">{children}</div>
    </Spin>
  );
};

export const GridView = ({
  data,

  children,
  isLoading = false,
  emptyTitle,
  emptyBody,
}) => {
  if (data?.length === 0) {
    return (
      <Empty description={emptyTitle ?? "No Data Available!"}>
        {emptyBody && emptyBody}
      </Empty>
    );
  }
  return (
    <Spin spinning={isLoading} tip="Loading" size="large">
      <Row gutter={[24, 24]}>{children}</Row>
      {/* <div className="grid_view">{children}</div> */}
    </Spin>
  );
};

export const CardTitle = ({ title }) => {
  return (
    <Tooltip
      style={{ borderRadius: "6px !important" }}
      mouseEnterDelay={0}
      mouseLeaveDelay={0}
      title={title}
    >
      <div
        style={{
          fontSize: "20px",
          fontWeight: "400",
          width: "200px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {title}
      </div>
    </Tooltip>
  );
};

export default withDomains(
  OrganizationList,
  "user",
  "auth",
  "upgradeCredentials",
  "register"
);
